// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToggle__DrawerToggle__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.css
// module id = 67
// module chunks = 0